import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { getUserDetails } from "../../redux/postReducer/UserPost";
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { logout } from "../../redux/getReducer/UserSlice";
const ProtectedRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userToken, userInfo } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(true); // New loading state
  const [userApproved, setUserApproved] = useState(false);

  const handleback = () => {
    navigate("/");
  };
  const verifyUser = async () => {
    try {
      const res = await axios.get(`${window.env.API_URL}/AdminToken`);
      console.log(res);
      setUserApproved(true);
    } catch (err) {
      setUserApproved(false);
      dispatch(logout());
      navigate("/");
      Cookies.remove("userToken");
    }
  };

  useEffect(() => {
    verifyUser();
  }, []);

  console.log(userInfo, "userInfo");

  if (!Cookies.get("userToken") && !userApproved) {
    return (
      <div style={styles.container}>
        <div style={styles.section}>
          <h1 style={styles.error}>404</h1>
          <div style={styles.page}>Ooops!!! You are not Authorized</div>
          <a style={styles.backHome} onClick={handleback}>
            Back to home
          </a>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // Full viewport height
    flexDirection: "column",
    textAlign: "center",
    width: "100%",
  },
  section: {
    padding: "4rem 2rem",
  },
  error: {
    fontSize: "150px",
    color: "#292D76",
    textShadow: `
      1px 1px 1px #292D76,    
      2px 2px 1px #292D76,
      3px 3px 1px #292D76,
      4px 4px 1px #292D76,
      5px 5px 1px #292D76,
      6px 6px 1px #292D76,
      7px 7px 1px #292D76,
      8px 8px 1px #292D76,
      25px 25px 8px rgba(0, 0, 0, 0.2)
    `,
  },
  page: {
    margin: "2rem 0",
    fontSize: "20px",
    fontWeight: "600",
    color: "#444",
  },
  backHome: {
    display: "inline-block",
    border: "2px solid #222",
    color: "#fff",
    textTransform: "uppercase",
    fontWeight: "600",
    padding: "0.75rem 1rem 0.6rem",
    transition: "all 0.2s linear",
    boxShadow: "0 15px 15px -11px rgba(0, 0, 0, 0.4)",
    background: "#222",
    borderRadius: "6px",
    textDecoration: "none",
    cursor: "pointer",
  },
  backHomeHover: {
    background: "#222",
    color: "#ddd",
  },
};

export default ProtectedRoute;
